import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AasService {

  // 后端微服务famWebAPI地址
  private prefix: string = environment.famWebAPI;
  private filePrefix: string = environment.fileWebAPI;
  constructor(private http: SwHttpClientService) { }

  /**
   * 分页查询三维模型列表页
   * @param param 
   */
  queryThreeDModelListByPage(param) {
    const url = this.prefix + 'fileDetail/queryByPage';
    return this.http.Post(url, param);
  }

  /**
   * 批量删除三维模型记录
   * @param param fileInfoId
   */
  deleteBatchThreeDModel(param) {
    const url = this.prefix + 'fileDetail/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 根据主键获取文件详情
   * @param id fileDetailId
   */
  queryFileDetailById(id) {
    const url = this.prefix + 'fileDetail/queryById/' + id;
    return this.http.Get(url);
  }

  /**
   * 保存附件详细信息
   * @param param 
   */
  saveFileDetail(param) {
    const url = this.prefix + 'fileDetail/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改文件详细信息
   * @param param 
   */
  updateFileDetail(param) {
    const url = this.prefix + 'fileDetail/update';
    return this.http.Post(url, param);
  }

  // ------------------------资料管理 start-----------------------------
  queryAasDocumentListByPage(param) {
    const url = this.prefix + 'aasDocument/queryByPage';
    return this.http.Post(url, param);
  }


  deleteAasDocument(param) {
    const url = this.prefix + 'aasDocument/delete';
    return this.http.Post(url, param);
  }

  queryAasDocumentById(id: string) {
    const url = this.prefix + `aasDocument/queryById/${id}`;
    return this.http.Get(url);
  }

  saveAasDocument(param: any) {
    const url = this.prefix + 'aasDocument/save';
    return this.http.Post(url, param);
  }

  updateAasDocument(param: any) {
    const url = this.prefix + 'aasDocument/update';
    return this.http.Post(url, param);
  }

  // ------------------------资料管理 end-----------------------------

  // ------------------------档案资料 start-----------------------------

  queryAasDataArchiveListByPage(projectId) {
    const url = this.prefix + `aasDataArchive/queryPageListByProject?projectId=${projectId}`;
    return this.http.Post(url, null);
  }

  queryChildNodesByObjectId(projectId, param) {
    const url = this.prefix + `aasDataArchive/queryChildNodesByObjectId?projectId=${projectId}`;
    return this.http.Post(url, param);
  }

  exportDocument(objectId) {
    const url = this.prefix + `aasDataArchive/exportDocument?objectId=${objectId}`;
    // return this.http.Post(url, null, { responseType: 'blob', observe: 'response', headers: headers });
    return this.http.PostExport(url, null);
  }

  downloadDocument(objectId) {
    const url = this.prefix + `aasDataArchive/downloadDocument?objectId=${objectId}`;
    // return this.http.Post(url, null, { responseType: 'blob', observe: 'response', headers: headers });
    return this.http.PostExport(url, null);
  }

 downloadZip(projectId, param) {
   const url = this.prefix + `aasDataArchive/downloadZip?projectId=${projectId}`;
   return this.http.PostExport(url, param);
 }

  /**
   * 创建档案下载任务。
   * @param projectId 当前项目ID
   * @param param 选中档案节点和是否下载图片
   * @returns 文件中心创建任务结果
   */
  createDownloadTask(projectId, param) {
    const url = this.prefix + `aasDataArchive/createDownloadTask`;
    param = param || {};
    param.projectId = projectId;
    return this.http.Post(url, param);
  }

  /**
   * 查询当前登录人的文件中心任务列表。
   * @param param 查询条件和分页参数
   * @returns 当前用户的下载和批量导入任务分页数据
   */
  queryDownloadTaskList(param) {
    const url = this.prefix + `aasDataArchive/queryDownloadTaskList`;
    return this.http.Post(url, param || {});
  }

  /**
   * 获取已完成下载任务的文件地址。
   * @param taskId 下载任务ID
   * @returns 后端校验后的文件下载地址
   */
  downloadTaskFile(taskId) {
    const url = this.prefix + `aasDataArchive/downloadTaskFile?taskId=${taskId}`;
    return this.http.Post(url, null);
  }

 queryResourcePage(param) {
    const url = this.prefix + `aasResource/queryPage`;
    return this.http.Post(url, param);
  }

  createNewFolder(param) {
    const url = this.prefix + `aasResource/createNewFolder`;
    return this.http.Post(url, param);
  }

  resourceSaveBatch(param) {
    const url = this.prefix + `aasResource/saveBatch`;
    return this.http.Post(url, param);
  }

  threeDResourceSaveBatch(param) {
    const url = this.prefix + `aasResource/threeDResourceSaveBatch`;
    return this.http.Post(url, param);
  }

  updateResource(param) {
    const url = this.prefix + `aasResource/update`;
    return this.http.Post(url, param);
  }

  resourceDeleteById(resourceId) {
    const url = this.prefix + `aasResource/deleteById?resourceId=${resourceId}`;
    return this.http.Post(url, null);
  }

  getResourceFolderTree(projectId, type) {
    const url = this.prefix + `aasResource/getFolderTree?projectId=${projectId}&type=${type}`;
    return this.http.Post(url, null);
  }

  createDocByHistoryData(projectId) {
    const url = this.prefix + `aasDataArchive/createDocByHistoryData?projectId=${projectId}`;
    return this.http.Get(url, null);
  }


  // ------------------------档案资料 end-----------------------------

  /**
   * 转换三维模型
   * @param fileInfoId
   * @param isAsync 
   * @returns 
   */
  convertThreeModel(fileInfoId: string, isAsync: boolean = true) {
    const url = this.filePrefix + 'threeModel/convert';
    return this.http.Post(url, { fileInfoId: fileInfoId, isAsync: isAsync });
  }

}
